import {
  Directive,
  Output,
  EventEmitter,
  ElementRef,
  Input,
} from '@angular/core';
import * as debug from 'debug';
import * as $ from 'jquery';
import * as _ from 'lodash';

/**
 * Generated class for the SwipeDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[swipe]', // Attribute selector
})
export class SwipeDirective {
  log = debug('app:SwipeDirective');

  @Input() swipeThreshold = 10;
  @Input() swipeMoveDown = false;
  @Output() swipeDown = new EventEmitter();
  @Output() swipeUp = new EventEmitter();
  @Output() swipeLeft = new EventEmitter();
  @Output() swipeRight = new EventEmitter();

  constructor(public element: ElementRef) {
    this.log('hello', element);

    let startData, lastMove;

    $(element.nativeElement).on('touchstart', e => {
      startData = {
        y: _.get(_.last(e.targetTouches), 'screenY'),
        x: _.get(_.last(e.targetTouches), 'screenX'),
      };
      this.log('start data', startData, e);
    });

    $(element.nativeElement).on('touchmove', e => {
      lastMove = {
        y: _.get(_.last(e.targetTouches), 'screenY'),
        x: _.get(_.last(e.targetTouches), 'screenX'),
      };

      if (this.swipeMoveDown) {
        let diff = lastMove.y - startData.y;
        if (diff < 0) {
          diff = 0;
        }
        $(element.nativeElement).css({
          transform: 'translateY(' + diff + 'px)',
        });
      }
    });

    $(element.nativeElement).on('touchend', e => {
      this.log('touch end', e);
      this.log('start data', startData);
      this.log('end data', lastMove);

      if (!lastMove) {
        startData = null;
        return;
      }

      if (lastMove.y - this.swipeThreshold > startData.y) {
        this.swipeDown.emit();
      }

      if (lastMove.y + this.swipeThreshold < startData.y) {
        this.swipeUp.emit();
      }

      if (lastMove.x + this.swipeThreshold < startData.x) {
        this.swipeLeft.emit();
      }

      if (lastMove.x - this.swipeThreshold > startData.x) {
        this.swipeRight.emit();
      }

      startData = null;

      if (this.swipeMoveDown) {
        $(element.nativeElement).css({
          transform: 'none',
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/directives/swipe/swipe.ts